export const isDetailCheckBoxDisabled = (damagesList, detailsList, damage_code) => {
	const damage = damagesList?.find((damage) => damage?.placement?.find((placement) => placement.parts === damage_code));

	return damage ? true : false;
};
